/**
 * Converts a rich-text email body (from Email Template Master, typically
 * produced by a WYSIWYG editor) into plain text for a plain-text compose box.
 *
 * A naive `html.replace(/<[^>]+>/g, '')` strips tags but leaves HTML entities
 * (&nbsp;, &amp;, etc.) as literal text — those editors insert &nbsp; for
 * blank lines/spacing constantly, so every template body showed literal
 * "&nbsp;" in the sent email. Using the browser's own HTML parser (via a
 * detached element's textContent) decodes entities correctly, the same way
 * the browser would render them.
 */
export function htmlToPlainText(html: string): string {
  if (!html) return ''

  // Convert block-level boundaries to newlines BEFORE stripping tags, so
  // paragraph/line breaks survive (textContent alone collapses them away).
  const withBreaks = html
    .replace(/<\/(p|div|li|h[1-6]|tr)>/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n')

  const el = document.createElement('div')
  el.innerHTML = withBreaks
  const text = el.textContent || el.innerText || ''

  return text
    .replace(/\u00a0/g, ' ') // decoded &nbsp; -> regular space
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}
